import { Alert, Container, Grid, Link } from "@mui/material";
import React, {useState , useEffect } from "react";
// import { setUserSession } from './Utils/Common';
import DashBoardFooter from "../../../Components/DashboardFooter";
import Loader from "../../../Components/ErroBook/loader";
import ErrorBook from "../../../Components/ErroBook/ntErro"

import Web3 from "web3";

import logo from "../../../images/logo.png"
import playtable_half from "../../../images/playtable_half.png"
import ConnectScreen from "./connectscreen";

var web3;

const LoginScreen = () => {
    const [useUser, setUser] = useState('');
    const [usePassword, setPassword] = useState('');
    const [useUserError, setUserError] = useState(false);
    const [usePasswordError, setPasswordError] = useState(false);
    const [useWalletConnected, setWalletConnected] = useState(false);
    const [useWalletAddress, setWalletAddress] = useState('0x');
    const [usebuttonText, setbuttonText] = useState('Connect Wallet');
    const [useIncorrectWalletError, setIncorrectWalletError] = useState(false);
    
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    useEffect(()=> {
        connectWallet();
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[useError]);

    // 2=> conciseWallet
    const conciseWallet = (value) => {
        // const intvalue = value;
        if( value != "" && value != null){
            const start_char = value.toString().substring(0,4)+"....";
            const end_char = value.toString().substr(value.length - 4);
            return start_char + end_char
        }else{
            // setErrorType('walletNotConnected')
            // setError(true)
            return "Connect Wallet";
        }
    }
    // 3=> chainChanged   
    try {
        window.ethereum.on('connect',  ( _connectInfo => {
            // BSC 0x38
            // BSCTestnet 0x61
            if ( _connectInfo.chainId != "0x38") {
                setErrorType('wrongNetwork')
                setError(true)
            }
        }));
    } catch (error) {
        console.log(error)
    }     
    
    try {
        window.ethereum.on('chainChanged', (_chainId => {
            // BSC 0x38
            // BSCTestnet 0x61
            if ( _chainId == "0x38") {
                window.location.reload();
            }else{
                setLoader(true)
                setErrorType('wrongNetwork')
                setError(true)
            }
        }));
    } catch (error) {
        console.log(error)
    }
    // 4=> accountsChanged
    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            if( _mAddress != "" ){
                setErrorType('walletChanged')
                setError(true)
            }else{
                setWalletConnected(false)
                setErrorType('walletNotConnected')
                // setLoader(true)
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Address: ', error)
    }
    // 5=> connectWallet
    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){

            web3 = new Web3(window.ethereum);
            try {
                window.ethereum.request({ method: 'eth_chainId' }).then( _chainId => {
                    // BSC 0x38
                    // BSCTestnet 0x61
                    if ( _chainId != "0x38") {
                        setLoader(true)
                        setErrorType('wrongNetwork')
                        setError(true)
                    }
                })                
            } catch (error) {
                console.log(error)
            }

            //get connected wallet address
            try {
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    setWalletAddress(_account.toString())
                    setWalletConnected(true)
                    setUser(_account.toString())
                    if( _account != ""){
                        if ( localStorage.getItem("userDbAddress") == _account.toString()) {
                            window.location.replace("/dashboard");
                        }else{
                            setbuttonText(conciseWallet(localStorage.getItem("userDbAddress")))
                            // setIncorrectWalletError(true)
                        }
                    }
                })
                .catch (error => {
                    console.log("test: " , error)
                    //setLoader(true)
                    setErrorType('walletNotConnected')
                    // setWalletConnected(false)
                    setError(true)
                });
            } catch (error) {
                setErrorType('noMetamask')
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }

    const handleInput = ( e, type) => {
        if (type == 'user') {
            let value = e.target.value;
            setUser( value )
        } else if (type == 'password'){
            let value = e.target.value;
            setPassword( value )
        }
    }
    const handleLogin = () => {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; 
        let dataToBeSend;

        

        if ( useUser == "") {
            setErrorType("empty-user")
            setError(true)
            return;
        }else{
            let wallletchar = useUser.substring(0, 2);
            if (wallletchar != "0x") {
                if ( !useUser.match(pattern) ) {
                    setErrorType("invalid-email")
                    setError(true)
                    return;
                }else{
                    dataToBeSend = {
                        email: useUser,
                        password: usePassword,
                    }
                }
            }else{
                if ( useUser.length != 42) {
                    setErrorType("too-short-address")
                    setError(true)
                    return;
                }else{
                    dataToBeSend = {
                        address: useUser,
                        password: usePassword,
                    }
                }
            }
        }
        setError(false)
        
        if (usePassword == "") {
            setErrorType("empty-password")
            setError(true)
            return;
        }
        setError(false)
        setLoader(true)
        fetch('https://metasnooker.herokuapp.com/api/auth/login',{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(dataToBeSend)
        })
        .then(response => response.json())
        .then( jsonData => {
            console.log('Response Data: ', jsonData)
            setLoader(false)
            if(jsonData.token){
                if (jsonData.token != "" && jsonData.user.email != "" ) {
                    localStorage.setItem("email", jsonData.user.email);
                    localStorage.setItem("token", jsonData.token);
                    localStorage.setItem("userId", jsonData.user._id);
                    localStorage.setItem("userDbAddress", jsonData.user.address);

                    if (localStorage.getItem("userDbAddress") == useWalletAddress) {    
                        setErrorType("login-success")
                        setError(true) 
                        window.location.replace("/dashboard");
                    } else {
                        setbuttonText(conciseWallet(localStorage.getItem("userDbAddress")))
                        setIncorrectWalletError(true)
                    } 
                    // Set Item
                    console.log('User has been useWalletAddress: ', useWalletAddress )
                    console.log('User has been userDbAddress: ', localStorage.getItem("userDbAddress") )
                    
                } 
            }else{
                setErrorType(jsonData.message)
                setError(true)  
            }
        })
    }

    return(
        <div className="AppDapp position-relative">
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            { useWalletConnected ?
                <Container>
                    <Grid
                        container
                        justifyContent='center'
                        alignContent="space-between"
                        className="div"
                    >
                        <Grid
                            xs={12}
                            sm={8}
                            md={5}
                            lg={7}
                        ></Grid>
                        <Grid
                            xs={11}
                            sm={8}
                            md={7}
                            lg={5}
                            className="text-center mt-sm-5 pt-5"
                        >
                            <Link href="/" className="MS---dashboard--heading d-inline-block position-relative mb-5">
                                Login
                            </Link>
                            {useError ?
                                <ErrorBook 
                                    errorType = {useErrorType}
                                />
                            :
                                <span />
                            }
                            {useIncorrectWalletError ?
                                <Alert variant="filled" className="Global_form_error" severity="error">
                                    You are not connected with your registered wallet with this email. Your Registerd wallet is {usebuttonText}
                                </Alert>
                            :
                                <span />
                            }
                            <div className="MS---dapp_form px-3 py-5 p-sm-5">
                                <form>
                                    <label className="mb-2">Enter Email/Wallet Address</label>
                                    <input 
                                        type='text' 
                                        placeholder="e.g. 0x12345*******9876"
                                        className="mb-3"
                                        title={useUser}
                                        value={useUser}
                                        onChange={(event,type) =>handleInput(event,'user')}
                                    />
                                    <label className="mb-2">Password</label>
                                    <input 
                                        type='password' 
                                        placeholder="********"
                                        className="mb-3"
                                        value={usePassword}
                                        onChange={(event,type) =>handleInput(event,'password')}
                                    />
                                    <div className="text-right">
                                        <Link href="/forget-password" className="MS---blue-link" >
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <button
                                        type="button"
                                        className="MS---Neon--Button btn d-inline-block px-5 mt-4 mb-5"
                                        onClick={handleLogin}
                                    >
                                        Login
                                    </button>
                                    <p className="mb-0">
                                        Don't have an account? <Link href="/register" className="MS---pink-link">Register Account</Link>
                                    </p>
                                </form>
                            </div>
                        </Grid>
                        <Grid
                            container
                            xs={12}
                            className="mt-sm-5 py-5 px-sm-5"
                        >
                            <Grid
                                xs={12}
                                sm={8}
                                className="text-center text-sm-left"
                            >
                                <p className="mb-0">Metasnooker © 2022. All Rights Reserved.</p>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={4}
                                className="text-center text-sm-right mt-4 mt-sm-0"
                            >
                                <Link href="/terms" className="MS---blue-link" target="_blank">
                                    Terms & Conditions
                                </Link>
                                &nbsp;&nbsp;&nbsp;
                                <Link href="/privacy-policy" className="MS---blue-link" target="_blank">
                                    Privacy Policy
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            :
                <ConnectScreen 
                    connectFun = {connectWallet}
                />
            }
        </div>
    );
}

export default LoginScreen;